import {
  EmptyCartGQL,
  CartProductInput,
  DiscountDtoInput,
  ShoppingCartType,
  RemoveFromCartGQL,
  AddDiscountToCartGQL,
  FindShoppingCartByUserGQL,
  ValidateShoppingCartByCurrentUserGQL,
} from '@sifca-monorepo/ecommerce-generator';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, tap } from 'rxjs';

import { LonLatInput } from '@sifca-monorepo/ecommerce-generator';


@Injectable({
  providedIn: 'root',
})
export class ShoppingCartService {
  // Private
  private shoppingCart: BehaviorSubject<ShoppingCartType | null> = new BehaviorSubject(null);

  /**
   * Constructor
   */
  constructor(
    private emptyCartGQL: EmptyCartGQL,
    private removeFromCartGQL: RemoveFromCartGQL,
    private addDiscountToCartGQL: AddDiscountToCartGQL,
    private findShoppingCartByUserGQL: FindShoppingCartByUserGQL,
    private validateShoppingCartByCurrentUserGQL: ValidateShoppingCartByCurrentUserGQL,
    ) {}

  // -----------------------------------------------------------------------------------------------------
  // @ Accessors
  // -----------------------------------------------------------------------------------------------------

  /**
   * Getter for shoppingCart
   */
  get shoppingCart$(): Observable<ShoppingCartType> {
    return this.shoppingCart.asObservable();
  }

  findShoppingCartByUser(id: string): Observable<ShoppingCartType> {
    return this.findShoppingCartByUserGQL
      .fetch({
        id,
      })
      .pipe(
        tap((response: any) => {
          if (response.data) {
            return response.data.findShoppingCartByUser;
          }
        }),
      );
  }

  validateShoppingCart(location: LonLatInput): Observable<ShoppingCartType> {
    return this.validateShoppingCartByCurrentUserGQL
      .fetch({
        location,
      })
      .pipe(
        tap((response: any) => {
          if (response.data) {
            return response.data.validateShoppingCartByCurrentUser;
          }
        }),
      );
  }

  addDiscountToCart(id: string, input: DiscountDtoInput): Observable<ShoppingCartType> {
    return this.addDiscountToCartGQL
      .mutate({
        id,
        input,
      })
      .pipe(
        tap((response: any) => {
          if (response.data) {
            return response.data.addDiscountToCart;
          }
        }),
      );
  }

  removeFromCart(pos: string, product: CartProductInput): Observable<ShoppingCartType> {
    return this.removeFromCartGQL
      .mutate({
        target: { pos },
        product,
      })
      .pipe(
        tap((response: any) => {
          if (response.data) {
            return response.data.removeFromCart;
          }
        }),
      );
  }

  emptyCart(): Observable<ShoppingCartType> {
    return this.emptyCartGQL.mutate().pipe(
      tap((response: any) => {
        if (response.data) {
          return response.data.emptyCart;
        }
      }),
    );
  }
}
